import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Badge } from '@/components/ui/badge';
import { Check, RotateCcwClock } from 'lucide-react';
import { formatDateTime } from '../../../../Resources/utils/dateUtils';

export function StatusVersionBanner({ timestamp }: { timestamp?: Date }) {
  return (
    <div className="tw:hidden tw:items-center tw:justify-between tw:rounded-lg tw:border-2 tw:border-success tw:bg-success tw:px-3 tw:py-1 tw:text-success-foreground">
      <span className="tw:text-xs">
        {timestamp
          ? 'Last updated at ' + formatDateTime(timestamp.toString())
          : ''}
      </span>
      <div className="tw:flex tw:items-center tw:gap-2">
        <Button size="sm" variant="outline" disabled className="tw:hidden">
          Create Signed Version
        </Button>
        <DropdownMenu disabled>
          <DropdownMenuTrigger
            render={
              <Button variant="outline" size="sm" className="tw:hidden" />
            }
          >
            <RotateCcwClock /> Versions
          </DropdownMenuTrigger>
          <DropdownMenuContent>
            <DropdownMenuItem className="tw:flex tw:justify-between">
              <div className="tw:flex tw:items-center tw:gap-2">
                <RotateCcwClock />
                <span>Version history</span>
              </div>
              <Badge>0</Badge>
            </DropdownMenuItem>
            <DropdownMenuItem className="tw:flex tw:justify-between">
              <div className="tw:flex tw:items-center tw:gap-2">
                <Check />
                <span>Signed versions</span>
              </div>

              <Badge>0</Badge>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </div>
  );
}
